// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### 23-09-05 Komarov
import moment from 'moment';
// ##### 23-03-29 Komarov
import 'moment/locale/uk';

// ##### 23-09-14 Komarov
// import './HotelItemsCSS.css'
import config from '../../../../../Redux/config';
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import HotelItemContent from './HotelItemContent';
// ##### 25-05-02 Komarov
// ##### 25-05-10 Komarov
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const HotelContent = ({ id }) => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);

  // ##### 23-03-01 Komarov
  return (
    <div className="WrapperHotel_ItemContent" data-component="HotelContent">
      {/* ##### 23-11-13 Komarov */}
      <Media greaterThanOrEqual="Tablet-768-1024">
        <HotelItemContent
          ulCLassName="Hotel_ItemContent"
          liClassName="Li_HotelContent"
          liImageClassName="Li_Image"
          divHotelNameStarRatingClassName="HotelNameStarRating"
          width="18vw"
          height="14vw"
          // ##### 25-04-21 Komarov
          id={id} // hotel's id
        />
      </Media>
      {/* ##### 23-11-13 Komarov */}
      <Media lessThan="Tablet-768-1024">
        <HotelItemContent
          ulCLassName="Hotel_ItemContentSmallScreen"
          liClassName="Li_HotelContentSmallScreen"
          liImageClassName="Li_ImageSmallScreen"
          divHotelNameStarRatingClassName="HotelNameStarRatingSmallScreen"
          divHotelAddressClassName="HotelAddressSmallScreen"
          width="90%"
          height="100%"
          // ##### 25-04-21 Komarov
          id={id} // hotel's id
        />
      </Media>
    </div>
  );
};

export default HotelContent;
